<template>
  <div v-if="!rp.exist_in_cart" class="col-12 col-sm-4 col-md-4 col-lg-4 mb-5">
    <a class="product product--related-popup" :href="rp.url" target="_blank">
      <div class="product__image-block">
        <img :src="rp.thumb_url" alt="" class="product__image">
      </div>
      <div class="product__favorite-btn js-add-to-wishlist" :data-product-id="rp.id">
        <svg-icon icon="heart" class="icon-heart"></svg-icon>
      </div>
      <div class="product__category">{{rp.category.name}}</div>
      <div class="product__name">{{rp.name}}</div>

      <div class="product__price-block" v-if="!added_in_cart">
        <div class="product__price product__price--compare" v-if="rp.base_price">
          <span><price-formatted :value="rp.base_price"/></span>
        </div>
        <div class="product__price"><price-formatted :value="rp.price"/></div>
        <div class="product__cart-btn" :data-product-id="rp.id" data-type="product-list" @click.prevent.stop="add_to_cart">
          <svg-icon icon="cart"></svg-icon>
        </div>
      </div>
      <div class="product__price-block" v-else>
        <div class="button-white product__price-btn js-prevent-bubble" @click.prevent="">Добавлено</div>
      </div>
    </a>
  </div>
</template>

<script>
  import API from '@MAIN/app/api'

  export default {
    props : {
      rp : {
        required: true
      }
    },
    data() {
      return {
        disabled : false,
        added_in_cart : false,
      }
    },
    methods : {
      add_to_cart() {
        this.disabled = true

        API.cart.add(this.rp.id).then(cart => {
          Object.assign(window.CART_FULL, cart)

          this.disabled = false
          this.added_in_cart = true
        })
      },
    }
  }
</script>
